import React from 'react';

import HeartLoader from '@app/components/UI/HeartLoader/HeartLoader';

interface BookingLoaderProps {
	loading: boolean;
	errorMessage: string;
	typeButton?: 'button' | 'submit';
	children?: React.ReactNode;
	forceDeleteTimer?: boolean;
	removeIfError?: boolean;
	onClick?: () => void;
}

const BookingLoader: React.FC<BookingLoaderProps> = ({
	loading,
	errorMessage,
	typeButton = 'button',
	children = null,
	forceDeleteTimer = false,
	removeIfError = true,
	onClick,
}) => {
	const [timer, setTimer] = React.useState<NodeJS.Timeout | undefined>(undefined);
	const [seconds, setSeconds] = React.useState<number>(0);

	const startTimer = () => {
		let count = 0;
		setSeconds(count);

		setTimer(
			setInterval(() => {
				count += 1;
				setSeconds(count);
			}, 1000),
		);
	};

	const clearTimer = (deleteTimer = false) => {
		if (timer) {
			clearInterval(timer);

			if (deleteTimer) {
				setTimer(undefined);
				setSeconds(0);
			}
		}
	};

	React.useEffect(() => {
		if (loading) {
			startTimer();
		}
		if (!loading && !errorMessage.length && navigator.onLine) {
			clearTimer(true);
		}
	}, [loading]);

	React.useEffect(() => {
		if (errorMessage.length) {
			clearTimer(removeIfError);
		}
	}, [errorMessage.length]);

	React.useEffect(() => {
		if (seconds >= 20) {
			clearTimer();
		}
	}, [seconds]);

	React.useEffect(() => {
		if (forceDeleteTimer) {
			clearTimer(true);
		}
	}, [forceDeleteTimer]);

	return timer || loading ? (
		errorMessage.length || seconds >= 20 ? (
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>
						We’re sorry, but we’re having some technical difficulties. If you need immediate assistance,
						please call us at
						{' '}
						<a href="tel:8559335683" className="inline-block inline-link"> (855)933-5683.</a>
					</p>
				</div>
				<button
					type={typeButton}
					className="btn btn-md btn-primary link"
					onClick={onClick}
				>
					Retry
				</button>
			</div>
		) : seconds < 10 ? (
			<HeartLoader />
		) : seconds < 20 ? (
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>Please bear with us - things are taking a bit longer than usual. Thank you for your patience.</p>
				</div>
				<HeartLoader />
			</div>
		) : null
	) : (
		<>{children}</>
	);
};

export default BookingLoader;
